import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import useApi from '../../api/useApi';
import '../../scrollbar.css';

function FloorPlan() {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(sessionStorage.user).organization.id;
  const [openCreate, setOpenCreate] = useState(false);
  const [{ isLoading, isError, data }] = useApi();
  const [floormapState, uploadFloormap] = useApi();
  const [zones, zoneData] = useApi();
  const [typeMatch, setTypeMatch] = useState(true);
  const [floorData, setfloorData] = useState({
    id: '',
    floorImage: '',
  });
  const [zone, setzone] = useState([]);
  const [id, setId] = useState(null);
  const history = useHistory();
  const [floorMap, setFloorMap] = useState('');

  const fileRef = useRef();

  const handleChange = (e) => {
    const fileType = ["image/jpeg", 'image/png', 'application/pdf']
    const [file] = e.target.files;
    if(file) {
      if(file && fileType.includes(file.type)) {
        setFloorMap(file);
        setTypeMatch(false);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const x = new FormData();
    // var reg = /(.*?)\.(jpg|bmp|jpeg|png)$/;
    x.append('file', floorMap, floorMap.name);
    uploadFloormap(`/device/${floorData.id}/floorPlan`, 'POST', x);
  };

  useEffect(() => {
    user && zoneData(`/zones`, 'GET');
  }, []);

  useEffect(() => {
    if (!zones.isLoading && !zones.isError && zones.data) {
      const _zones = zones.data.zones.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
      setzone(_zones);

      // for (let i = 0; i < _zones.length; i++) {
      //   if (_zones[i].gateways.length > 0 && _zones[i].gateways[0].latitude && _zones[i].gateways[0].longitude) {
      //     cor.push({
      //       lat: parseFloat(_zones[i].gateways[0].latitude),
      //       lng: parseFloat(_zones[i].gateways[0].longitude),
      //     });
      //   }
      // }
      // setCoordinates(cor);
    }
  }, [zones.isLoading, zones.isError, zones.data]);

  useEffect(() => {
    if (!floormapState.isLoading && !floormapState.isError && floormapState.data) {
      user && zoneData(`/zones`, 'GET');
      setfloorData({ id: '', floorImage: '' });
      setFloorMap('');
    }
  }, [floormapState.isLoading, floormapState.isError, floormapState.data]);

  return (
    <>
      <div
        className="h-full fixed hideScroll m-8 w-full left-44 view_width"
        style={{ filter: openCreate && 'blur(2px)', overflow: 'auto', left: '14%', width: '81%' }}
      >
        <div className="absolute z-50 w-full top-12 flex">
          {!isLoading && (
            <div className="exampleZones border bg-tableBg absolute h-screen shadow-md max-w-screen-xl mx-auto sm:w-full w-1/5 px-3 py-3">
              {zone.length > 0 ? (
                <h1 className="text-base text-titleColor font-bold bg-white ml-3 mb-2">Floor Plan</h1>
              ) : (
                <h1 className="text-base text-titleColor text-center bg-white ml-3 mb-2">No Floor Plan Available</h1>
              )}
              <div
                className="pb-1 hideScroll"
                style={{ borderColor: '#e6e6e6', height: '78vh', overflow: 'auto', borderBottom: 'none' }}
              >
                {zone.length > 0 &&
                  // !openZone &&
                  zone.map((item, idx) => (
                    <div
                      className="my-2 px-3 py-1 bg-white flex rounded-md
                  shadow-sm relative border hover:border-indigo-200 focus-within:border-indigo-200"
                    >
                      <div className=" py-1 text-xs w-full">
                        <a
                          href="#"
                          className="font-bold text-textBlue1 capitalize text-sm"
                          onClick={(e) => {
                            setId(e.target.id);
                            setfloorData({ id: item.GatewayInfos[0].deviceId, floorImage: item.floorPlan });
                          }}
                          id={idx}
                        >
                          {` ${item.name !== null ? item.name : 'undefined'}`}
                        </a>
                        <div className="flex my-0 mt-1.5 text-titleColor font-medium text-xs">
                          {item?.Address?.city},{item?.Address?.country}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
          {isLoading && <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />}

          {/* {openZone && (
            <div className="border absolute bg-white" style={{ width: '78%', left: '21%', height: '83vh' }}>
              <ShowZone gatewayData={zone[id]} handleClose={toggleOpenZone} />
            </div>
          )} */}
        </div>
        {floorData.floorImage === null && (
          <div className="w-2/5 rounded-xl m-auto mt-40 bg-white">
            <form className="mt-2 mb-2 flex flex-wrap " onSubmit={handleSubmit} autoComplete="off">
              {/* <div className="inputLabelText px-4 py-2 mt-6 h-32 w-full"></div> */}
              <div className="w-full relative">
                <p className="font-bold text-sm text-textBlue1 border-b p-4 pb-1">Upload Floor Map</p>
                <div className="flex items-center">
                  <div
                    className="inputLabelText px-4 mt-6 py-4 focus:outline-none relative text-sm"
                    style={{ width: '92%', left: '4%', color: '#9B9B9B' }}
                    onClick={() => fileRef.current.click()}
                  >
                    <img src="assets/img/upload2.svg" className="w-5 mr-3 absolute right-0" alt="" />
                    {/* <input type="file"  ref={fileRef} onChange={handleChange} multiple={false} accept="image/x-png,image/jpeg" /> */}
                    <input ref={fileRef} onChange={handleChange} multiple={false} type="file" hidden />
                    Upload Floor Map
                  </div>
                  <span className="mt-5 ml-6 mr-4">{floorMap.name}</span>
                  {/* <input ref={fileRef} onChange={handleChange} multiple={false} type="file" hidden /> */}
                  {floormapState.isLoading && (
                    <img src="assets/img/loader.svg" className="w-16 transform translate-y-3" alt="" />
                  )}
                </div>
              </div>

              <div className="w-full flex mt-5 mb-2 relative ml-auto">
                {isLoading ? (
                  <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto bottom-0" alt="" />
                ) : (
                  // <div className="flex text-xs">
                  <>
                  {/* <div className="w-1/10" /> */}
                  <span className="text-red-400 w-2/5 ml-4 floorCss">*Filetype could be .jpg, .jpeg, .png and .svg</span>
                  <div className="w-1/10" />
                  <button
                    type="submit"
                    className="rounded-3xl w-2/5 float-right focus:outline-none h-10 text-white bg-primary cursor-pointer "
                    style={{ border: '1px solid #16406D' }}
                    disabled={typeMatch}
                  >
                    Save
                  </button>
                  </>
                  // </div>
                )}
              </div>
            </form>
          </div>
        )}
        {floorData.floorImage !== null && <img src={floorData.floorImage} />}
      </div>
    </>
  );
}

export default FloorPlan;
